import { rootPath } from './root-path'
import { isProduction } from 'utils/env'

const studioRootPath = isProduction
  ? 'https://studio.creativefabrica.com'
  : 'https://studio.staging.creativefabrica.com'

const myAccountPath = process.env.NEXT_PUBLIC_MY_ACCOUNT_PATH || '/my-account/'

export const AppRoutes = {
  HOME: '/',
  CONTENT: '/content/',
  STUDIO: '/studio/',
  STUDIO_LEARN_STUDIO_FOR_CRAFTERS: '/studio/learn/studio-for-crafters/',
  STUDIO_LEARN_STUDIO_WORKSPACE_GUIDE: '/studio/learn/studio-workspace-guide/',
  STUDIO_LEARN_STUDIO_FOR_PRINT_ON_DEMAND: '/studio/learn/studio-for-print-on-demand/',
  STUDIO_LEARN_GRAPHIC_DESIGN_GUIDE: '/studio/learn/graphic-design/guide/',
  STUDIO_LEARN_STUDIO_FOR_MARKETING: '/studio/learn/studio-for-marketing/',
  STUDIO_LEARN_AI_ART_GUIDE: '/studio/learn/ai-art-guide/',
  STUDIO_LEARN_ETSY_GUIDE: '/studio/learn/etsy-guide/',
  STUDIO_PLAN: '/studio/plan/',
  STUDIO_LICENSE: '/studio/license/',
  STUDIO_TEMPLATES: '/studio/templates/',
  STUDIO_TEMPLATES_FAVORITES: '/studio/templates/favorites/',
  STUDIO_TEMPLATES_ITEM: '/studio/templates/item/',
  STUDIO_FEATURES: '/studio/features/',
  STUDIO_TERMS_TERMS_OF_SERVICE: '/studio/terms/terms-of-service/',
  STUDIO_TERMS_PRIVACY_POLICY: '/studio/terms/privacy-policy/',
  STUDIO_TERMS_AFFILIATES: '/studio/terms/affiliates/',
  STUDIO_TERMS_CANCELLATION_POLICY: '/studio/terms/cancellation-policy/',
  STUDIO_FEATURES_BACKGROUND_REMOVER: '/studio/features/background-remover/',
  STUDIO_FEATURES_AI_IMAGE_EXTENDER: '/studio/features/ai-image-extender/',
  STUDIO_FEATURES_FLYER_MAKER: '/studio/features/flyer-maker/',
  STUDIO_FEATURES_BUSINESS_FLYER_MAKER: '/studio/features/business-flyer-maker/',
  STUDIO_FEATURES_PARTY_FLYER_MAKER: '/studio/features/party-flyer-maker/',
  STUDIO_FEATURES_REAL_ESTATE_FLYER_MAKER: '/studio/features/real-estate-flyer-maker/',
  STUDIO_FEATURES_CLUB_FLYER_MAKER: '/studio/features/club-flyer-maker/',
  STUDIO_FEATURES_BAND_FLYER_MAKER: '/studio/features/band-flyer-maker/',
  STUDIO_FEATURES_VECTORIZE_IMAGE: '/studio/features/vectorize-image/',
  STUDIO_FEATURES_JPG_TO_SVG_CONVERTER: '/studio/features/jpg-to-svg-converter/',
  STUDIO_FEATURES_PNG_TO_SVG_CONVERTER: '/studio/features/png-to-svg-converter/',
  STUDIO_FEATURES_ROTATE_IMAGE: '/studio/features/rotate-image/',
  STUDIO_FEATURES_CROP_IMAGE: '/studio/features/crop-image/',
  STUDIO_FEATURES_TRANSPARENT_BACKGROUND_MAKER: '/studio/features/transparent-background-maker/',
  STUDIO_FEATURES_MIRROR_IMAGE: '/studio/features/mirror-image/',
  STUDIO_FEATURES_JPG_TO_PDF_CONVERTER: '/studio/features/jpg-to-pdf-converter/',
  STUDIO_FEATURES_JPG_TO_PNG_CONVERTER: '/studio/features/jpg-to-png-converter/',
  STUDIO_FEATURES_CHANGE_COLOR_OF_IMAGE: '/studio/features/change-color-of-image/',
  STUDIO_FEATURES_JPEG_TO_JPG_CONVERTER: '/studio/features/jpeg-to-jpg-converter/',
  STUDIO_FEATURES_BLACK_AND_WHITE_FILTER: '/studio/features/black-and-white-filter/',
  STUDIO_FEATURES_CHANGE_PHOTO_BACKGROUND_COLOR: '/studio/features/change-photo-background-color/',
  STUDIO_FEATURES_ADD_TEXT_ON_IMAGE: '/studio/features/add-text-on-image/',
  STUDIO_FEATURES_ADD_EMOJI_TO_PHOTO: '/studio/features/add-emoji-to-photo/',
  STUDIO_FEATURES_PNG_TO_JPG_CONVERTER: '/studio/features/png-to-jpg-converter/',
  STUDIO_FEATURES_CIRCLE_CROP: '/studio/features/circle-crop/',
  STUDIO_FEATURES_OVERLAY_IMAGES: '/studio/features/overlay-images/',
  STUDIO_FEATURES_COMBINE_IMAGES: '/studio/features/combine-images/',
  STUDIO_FEATURES_REMOVE_BACKGROUND_FROM_LOGO: '/studio/features/remove-background-from-logo/',
  STUDIO_FEATURES_RESIZE_PHOTO_FOR_INSTAGRAM: '/studio/features/resize-photo-for-instagram/',
  STUDIO_FEATURES_CROP_PNG: '/studio/features/crop-png/',
  STUDIO_FEATURES_RESIZE_JPEG: '/studio/features/resize-jpeg/',
  STUDIO_FEATURES_RESIZE_ICON: '/studio/features/resize-icon/',
  STUDIO_FEATURES_RESIZE_PNG: '/studio/features/resize-png/',
  STUDIO_FEATURES_CROP_JPG: '/studio/features/crop-jpg/',
  STUDIO_FEATURES_IMAGE_ENHANCER: '/studio/features/image-enhancer/',
  STUDIO_FEATURES_BLUR_IMAGE: '/studio/features/blur-image/',
  STUDIO_FEATURES_DARKEN_IMAGE: '/studio/features/darken-image/',
  STUDIO_FEATURES_EDIT_PDF: '/studio/features/edit-pdf/',
  STUDIO_FEATURES_SHARPEN_IMAGE: '/studio/features/sharpen-image/',
  STUDIO_FEATURES_PHOTO_FILTER_EFFECTS: '/studio/features/photo-filter-effects/',
  STUDIO_FEATURES_WATERMARK_TO_PHOTOS: '/studio/features/watermark-to-photos/',
  STUDIO_FEATURES_BLUR_BACKGROUND: '/studio/features/blur-background/',
  STUDIO_FEATURES_UNBLUR_IMAGE: '/studio/features/unblur-image/',
  STUDIO_FEATURES_AI_INPAINTING_TOOL: '/studio/features/ai-inpainting-tool/',
  STUDIO_FEATURES_ANIMATE_PICTURES: '/studio/features/animate-pictures/',
  STUDIO_FEATURES_3D_LOGO_MAKER: '/studio/features/3d-logo-maker/',
  STUDIO_FEATURES_AI_HEADSHOT_GENERATOR: '/studio/features/ai-headshot-generator/',
  STUDIO_FEATURES_AI_LOGO_MAKER: '/studio/features/ai-logo-maker/',
  STUDIO_FEATURES_AI_PORTRAIT_GENERATOR: '/studio/features/ai-portrait-generator/',
  STUDIO_FEATURES_BUSINESS_POSTCARD_DESIGNER: '/studio/features/business-postcard-designer/',
  STUDIO_FEATURES_CLOTHING_LOGO_DESIGNER: '/studio/features/clothing-logo-designer/',
  STUDIO_FEATURES_DISCORD_LOGO_MAKER: '/studio/features/discord-logo-maker/',
  STUDIO_FEATURES_ETSY_SHOP_LOGO_MAKER: '/studio/features/etsy-shop-logo-maker/',
  STUDIO_FEATURES_GAMING_LOGO_MAKER: '/studio/features/gaming-logo-maker/',
  STUDIO_FEATURES_HEIC_TO_JPG_CONVERTER: '/studio/features/heic-to-jpg-converter/',
  STUDIO_FEATURES_IMAGE_COMPRESSOR: '/studio/features/image-compressor/',
  STUDIO_FEATURES_IMAGE_CONVERTER: '/studio/features/image-converter/',
  STUDIO_FEATURES_INSTAGRAM_LOGO_MAKER: '/studio/features/instagram-logo-maker/',
  STUDIO_FEATURES_LOGO_MAKER: '/studio/features/logo-maker/',
  STUDIO_FEATURES_STICKER_MAKER: '/studio/features/sticker-maker/',
  STUDIO_FEATURES_WHATSAPP_STICKER_MAKER: '/studio/features/whatsapp-sticker-maker/',
  STUDIO_FEATURES_MAGIC_ERASER: '/studio/features/magic-eraser/',
  STUDIO_FEATURES_MEME_GENERATOR: '/studio/features/meme-generator/',
  STUDIO_FEATURES_PDF_TO_JPG_CONVERTER: '/studio/features/pdf-to-jpg-converter/',
  STUDIO_FEATURES_WEBP_TO_JPG_CONVERTER: '/studio/features/webp-to-jpg-converter/',
  STUDIO_FEATURES_PNG_LOGO_MAKER: '/studio/features/png-logo-maker/',
  STUDIO_FEATURES_WORD_SEARCH_MAKER: '/studio/features/word-search-maker/',
  STUDIO_FEATURES_RESUME_BUILDER: '/studio/features/resume-builder/',
  STUDIO_FEATURES_TWITCH_LOGO_MAKER: '/studio/features/twitch-logo-maker/',
  STUDIO_FEATURES_YOUTUBE_LOGO_MAKER: '/studio/features/youtube-logo-maker/',
  STUDIO_FEATURES_ANIMATED_LOGO_CREATOR: '/studio/features/animated-logo-creator/',
  STUDIO_FEATURES_POSTCARD_MAKER: '/studio/features/postcard-maker/',
  STUDIO_FEATURES_PICTURE_POSTCARD_MAKER: '/studio/features/picture-postcard-maker/',
  STUDIO_FEATURES_DESIGN_A_POSTCARD_MAILER: '/studio/features/design-a-postcard-mailer/',
  STUDIO_FEATURES_COVER_LETTER_GENERATOR: '/studio/features/cover-letter-generator/',
  STUDIO_FEATURES_PORTFOLIO_MAKER: '/studio/features/portfolio-maker/',
  STUDIO_FEATURES_ANIMATED_GIF_MAKER: '/studio/features/animated-gif-maker/',
  STUDIO_FEATURES_POSTER_MAKER: '/studio/features/poster-maker/',
  STUDIO_FEATURES_DIWALI_POSTER_MAKER: '/studio/features/diwali-poster-maker/',
  STUDIO_FEATURES_CAMPAIGN_POSTER_MAKER: '/studio/features/campaign-poster-maker/',
  STUDIO_FEATURES_WANTED_POSTER_MAKER: '/studio/features/wanted-poster-maker/',
  STUDIO_FEATURES_MOVIE_POSTER_MAKER: '/studio/features/movie-poster-maker/',
  STUDIO_FEATURES_PHOTO_COLLAGE_MAKER: '/studio/features/photo-collage-maker/',
  STUDIO_FEATURES_FAMILY_PHOTO_COLLAGE_MAKER: '/studio/features/family-photo-collage-maker/',
  STUDIO_FEATURES_HAPPY_BIRTHDAY_PHOTO_COLLAGE_MAKER:
    '/studio/features/happy-birthday-photo-collage-maker/',
  STUDIO_FEATURES_LOVE_PHOTO_COLLAGE_MAKER: '/studio/features/love-photo-collage-maker/',
  STUDIO_FEATURES_TIMELINE_MAKER: '/studio/features/timeline-maker/',
  STUDIO_FEATURES_COLLEGE_SCHEDULE_MAKER: '/studio/features/college-schedule-maker/',
  STUDIO_FEATURES_BANNER_MAKER: '/studio/features/banner-maker/',
  STUDIO_FEATURES_TWITCH_BANNER_MAKER: '/studio/features/twitch-banner-maker/',
  STUDIO_FEATURES_TUMBLR_BANNER_MAKER: '/studio/features/tumblr-banner-maker/',
  STUDIO_FEATURES_ETSY_SHOP_BANNER_MAKER: '/studio/features/etsy-shop-banner-maker/',
  STUDIO_FEATURES_TWITTER_X_BANNER_MAKER: '/studio/features/twitter-x-banner-maker/',
  STUDIO_FEATURES_YOUTUBE_BANNER_MAKER: '/studio/features/youtube-banner-maker/',
  STUDIO_FEATURES_DIWALI_GREETING_CARD_MAKER: '/studio/features/diwali-greeting-card-maker/',
  STUDIO_FEATURES_BIRTHDAY_GREETING_CARD_MAKER: '/studio/features/birthday-greeting-card-maker/',
  STUDIO_FEATURES_PLACE_CARD_MAKER: '/studio/features/place-card-maker/',
  STUDIO_FEATURES_INFOGRAPHIC_MAKER: '/studio/features/infographic-maker/',
  STUDIO_FEATURES_QUINCEANERA_INVITATION_CARD_MAKER:
    '/studio/features/quinceanera-invitation-card-maker/',
  STUDIO_FEATURES_ALBUM_COVER_MAKER: '/studio/features/album-cover-maker/',
  STUDIO_FEATURES_LOHRI_INVITATION_CARD_MAKER: '/studio/features/lohri-invitation-card-maker/',
  STUDIO_FEATURES_SAVE_THE_DATE_CARD_MAKER: '/studio/features/save-the-date-card-maker/',
  STUDIO_FEATURES_ANIME_CHARACTER_CREATOR: '/studio/features/anime-character-creator/',
  STUDIO_FEATURES_BIRTHDAY_INVITATION_CARD_MAKER:
    '/studio/features/birthday-invitation-card-maker/',
  STUDIO_FEATURES_TABLE_MAKER: '/studio/features/table-maker/',
  STUDIO_FEATURES_BINGO_CARD_MAKER: '/studio/features/bingo-card-maker/',
  STUDIO_FEATURES_VALENTINES_CARD_MAKER: '/studio/features/valentines-card-maker/',
  STUDIO_FEATURES_CUSTOM_YARD_SIGN_MAKER: '/studio/features/custom-yard-sign-maker/',
  STUDIO_FEATURES_CARD_MAKER: '/studio/features/card-maker/',
  STUDIO_FEATURES_RELIGIOUS_PUJA_INVITATION_CARD_MAKER:
    '/studio/features/religious-puja-invitation-card-maker/',
  STUDIO_FEATURES_RECIPE_CARD_MAKER: '/studio/features/recipe-card-maker/',
  STUDIO_FEATURES_BOOK_COVER_MAKER: '/studio/features/book-cover-maker/',
  STUDIO_FEATURES_THANK_YOU_CARD_MAKER: '/studio/features/thank-you-card-maker/',
  STUDIO_FEATURES_EID_AL_FITR_GREETING_CARD_MAKER:
    '/studio/features/eid-al-fitr-greeting-card-maker/',
  STUDIO_FEATURES_CHRISTMAS_GREETING_CARD_MAKER: '/studio/features/christmas-greeting-card-maker/',
  STUDIO_FEATURES_QUIZ_MAKER: '/studio/features/quiz-maker/',
  STUDIO_FEATURES_ID_CARD_MAKER: '/studio/features/id-card-maker/',
  STUDIO_FEATURES_GRADUATION_CARD_MAKER: '/studio/features/graduation-card-maker/',
  STUDIO_FEATURES_YOUTUBE_THUMBNAIL_MAKER: '/studio/features/youtube-thumbnail-maker/',
  STUDIO_FEATURES_INVITATION_CARD_MAKER: '/studio/features/invitation-card-maker/',
  STUDIO_FEATURES_MOCKUP_GENERATOR: '/studio/features/mockup-generator/',
  STUDIO_FEATURES_SIGN_MAKER: '/studio/features/sign-maker/',
  STUDIO_FEATURES_BAPTISM_INVITATION_CARD_MAKER: '/studio/features/baptism-invitation-card-maker/',
  STUDIO_FEATURES_BRIDAL_SHOWER_INVITATION_CARD_MAKER:
    '/studio/features/bridal-shower-invitation-card-maker/',
  STUDIO_FEATURES_REPORT_CARD_MAKER: '/studio/features/report-card-maker/',
  STUDIO_FEATURES_ENGAGEMENT_INVITATION_CARD_MAKER:
    '/studio/features/engagement-invitation-card-maker/',
  STUDIO_FEATURES_BUSINESS_CARD_MAKER: '/studio/features/business-card-maker/',
  STUDIO_FEATURES_PARTY_INVITATION_CARD_MAKER: '/studio/features/party-invitation-maker/',
  STUDIO_FEATURES_WEDDING_INVITATION_CARD_MAKER: '/studio/features/wedding-invitation-card-maker/',
  STUDIO_FEATURES_3D_FACE_MAKER: '/studio/features/3d-face-maker/',
  STUDIO_FEATURES_4K_IMAGE_UPSCALER: '/studio/features/4k-image-upscaler/',
  STUDIO_FEATURES_AD_MAKER: '/studio/features/ad-maker/',
  STUDIO_FEATURES_ADD_CAPTION_TO_PHOTO: '/studio/features/add-caption-to-photo/',
  STUDIO_FEATURES_ADD_GLASSES_TO_PHOTO: '/studio/features/add-glasses-to-photo/',
  STUDIO_FEATURES_ADD_SNOW_FILTER_TO_PHOTO: '/studio/features/add-snow-filter-to-photo/',
  STUDIO_FEATURES_ADD_SPARKLES_EFFECT_TO_PHOTO: '/studio/features/add-sparkles-effect-to-photo/',
  STUDIO_FEATURES_ADD_SPEECH_BUBBLE_TO_PHOTO: '/studio/features/add-speech-bubble-to-photo/',
  STUDIO_FEATURES_AI_ARCHITECTURE_GENERATOR: '/studio/features/ai-architecture-generator/',
  STUDIO_FEATURES_AI_LANDSCAPE_GENERATOR: '/studio/features/ai-landscape-generator/',
  STUDIO_FEATURES_AI_PICTURE_HUE_CHANGER: '/studio/features/ai-picture-hue-changer/',
  STUDIO_FEATURES_AI_STYLE_TRANSFER: '/studio/features/ai-style-transfer/',
  STUDIO_FEATURES_AVATAR_MAKER: '/studio/features/avatar-maker/',
  STUDIO_FEATURES_BABY_SHOWER_INVITATION_MAKER: '/studio/features/baby-shower-invitation-maker/',
  STUDIO_FEATURES_BOOK_MAKER: '/studio/features/book-maker/',
  STUDIO_FEATURES_BOOK_MOCKUP_GENERATOR: '/studio/features/book-mockup-generator/',
  STUDIO_FEATURES_BOOKMARK_MAKER: '/studio/features/bookmark-maker/',
  STUDIO_FEATURES_CERTIFICATE_DESIGNER: '/studio/features/certificate-designer/',
  STUDIO_FEATURES_CHECKLIST_MAKER: '/studio/features/checklist-maker/',
  STUDIO_FEATURES_CHRISTENING_INVITATION_CARD_MAKER:
    '/studio/features/christening-invitation-card-maker/',
  STUDIO_FEATURES_CHRISTMAS_PHOTO_EDITOR: '/studio/features/christmas-photo-filter/',
  STUDIO_FEATURES_CLOTHING_COLLAGE_MAKER: '/studio/features/clothing-collage-maker/',
  STUDIO_FEATURES_COMIC_BOOK_FILTER: '/studio/features/comic-book-filter/',
  STUDIO_FEATURES_CUSTOM_BEER_LABEL: '/studio/features/custom-beer-label/',
  STUDIO_FEATURES_CUSTOM_BUMPER_STICKER_MAKER: '/studio/features/custom-bumper-sticker-maker/',
  STUDIO_FEATURES_CUSTOM_NAME_TAG_MAKER: '/studio/features/custom-name-tag-maker/',
  STUDIO_FEATURES_CUSTOMIZE_LOGO_STICKER: '/studio/features/customize-logo-sticker/',
  STUDIO_FEATURES_DAILY_SCHEDULE_MAKER: '/studio/features/daily-schedule-maker/',
  STUDIO_FEATURES_DESIGN_EMAIL_HEADER: '/studio/features/design-email-header/',
  STUDIO_FEATURES_DIGITAL_ART_MAKER: '/studio/features/digital-art-maker/',
  STUDIO_FEATURES_DISCORD_EMOJI_MAKER: '/studio/features/discord-emoji-maker/',
  STUDIO_FEATURES_DISNEY_FILTER: '/studio/features/disney-filter/',
  STUDIO_FEATURES_DOUBLE_EXPOSURE_IMAGES: '/studio/features/double-exposure-images/',
  STUDIO_FEATURES_DRIP_EFFECT: '/studio/features/drip-effect/',
  STUDIO_FEATURES_EBOOK_COVER_DESIGNER: '/studio/features/ebook-cover-designer/',
  STUDIO_FEATURES_FACEBOOK_COVER_PHOTO_MAKER: '/studio/features/facebook-cover-photo-maker/',
  STUDIO_FEATURES_FACEBOOK_EVENT_COVER_MAKER: '/studio/features/facebook-event-cover-maker/',
  STUDIO_FEATURES_FISH_EYE_CAMERA_FILTER: '/studio/features/fish-eye-camera-filter/',
  STUDIO_FEATURES_GIFT_CERTIFICATE_DESIGNER: '/studio/features/gift-certificate-designer/',
  STUDIO_FEATURES_GIFT_TAG_MAKER: '/studio/features/gift-tag-maker/',
  STUDIO_FEATURES_GREETING_CARD_CREATOR: '/studio/features/greeting-card-creator/',
  STUDIO_FEATURES_HALLOWEEN_PARTY_INVITATION_MAKER:
    '/studio/features/halloween-party-invitation-maker/',
  STUDIO_FEATURES_HEART_SHAPED_COLLAGE_MAKER: '/studio/features/heart-shaped-collage-maker/',
  STUDIO_FEATURES_HOLIDAY_PHOTO_CARDS_MAKER: '/studio/features/holiday-photo-cards-maker/',
  STUDIO_FEATURES_HOUSEWARMING_INVITATION_DESIGNER:
    '/studio/features/housewarming-invitation-designer/',
  STUDIO_FEATURES_INSTAGRAM_POST_GENERATOR: '/studio/features/instagram-post-generator/',
  STUDIO_FEATURES_INSTAGRAM_STORY_MAKER: '/studio/features/instagram-story-maker/',
  STUDIO_FEATURES_JPEG_ARTIFACTS: '/studio/features/remove-jpeg-artifacts/',
  STUDIO_FEATURES_LABEL_MAKER: '/studio/features/label-maker/',
  STUDIO_FEATURES_LENS_FLARE_EFFECT_FILTER: '/studio/features/lens-flare-effect-filter/',
  STUDIO_FEATURES_LESSON_PLAN_MAKER: '/studio/features/lesson-plan-maker/',
  STUDIO_FEATURES_LINKEDIN_BANNER_CREATOR: '/studio/features/linkedin-banner-creator/',
  STUDIO_FEATURES_MAGAZINE_COVER_MAKER: '/studio/features/magazine-cover-maker/',
  STUDIO_FEATURES_MENU_DESIGNER: '/studio/features/menu-designer/',
  STUDIO_FEATURES_NEGATIVE_IMAGE: '/studio/features/negative-image/',
  STUDIO_FEATURES_OLD_AGING_FILTER: '/studio/features/old-aging-filter/',
  STUDIO_FEATURES_ONLINE_DIGITAL_PLANNER: '/studio/features/online-digital-planner/',
  STUDIO_FEATURES_PAINT_BUCKET_TOOL: '/studio/features/paint-bucket-tool/',
  STUDIO_FEATURES_PASSPORT_PHOTO_PROCESSOR: '/studio/features/passport-photo-processor/',
  STUDIO_FEATURES_PHOTO_BODY_EDITOR: '/studio/features/photo-body-editor/',
  STUDIO_FEATURES_PHOTO_HEAD_SWAPPING: '/studio/features/photo-head-swapping/',
  STUDIO_FEATURES_PHOTO_MOSAIC_CREATOR: '/studio/features/photo-mosaic-creator/',
  STUDIO_FEATURES_PICTURE_ALBUM_BOOK_MAKER: '/studio/features/picture-album-book-maker/',
  STUDIO_FEATURES_PICTURE_TO_PAINTING_CONVERTER: '/studio/features/picture-to-painting-converter/',
  STUDIO_FEATURES_PRESENTATION_MAKER: '/studio/features/presentation-maker/',
  STUDIO_FEATURES_REAL_ESTATE_PHOTO_EDITING: '/studio/features/real-estate-photo-editing/',
  STUDIO_FEATURES_RED_HAIR_FILTER: '/studio/features/red-hair-filter/',
  STUDIO_FEATURES_REMOVE_TEXT_FROM_IMAGE: '/studio/features/remove-text-from-image/',
  STUDIO_FEATURES_REMOVE_WRINKLES_FROM_PHOTO: '/studio/features/remove-wrinkles-from-photo/',
  STUDIO_FEATURES_SCHEDULE_BUILDER: '/studio/features/schedule-builder/',
  STUDIO_FEATURES_SCRAPBOOK_PAGE_MAKER: '/studio/features/scrapbook-page-maker/',
  STUDIO_FEATURES_SOUNDCLOUD_BANNER_MAKER: '/studio/features/soundcloud-banner-maker/',
  STUDIO_FEATURES_SPORTS_PICTURE_COLLAGE_MAKER: '/studio/features/sports-picture-collage-maker/',
  STUDIO_FEATURES_STORYBOARD_CREATOR: '/studio/features/storyboard-creator/',
  STUDIO_FEATURES_T_SHIRT_MOCKUP_GENERATOR: '/studio/features/t-shirt-mockup-generator/',
  STUDIO_FEATURES_TABLE_OF_CONTENTS_MAKER: '/studio/features/table-of-contents-maker/',
  STUDIO_FEATURES_THERMAL_FILTER: '/studio/features/thermal-filter/',
  STUDIO_FEATURES_TIER_LIST_MAKER: '/studio/features/tier-list-maker/',
  STUDIO_FEATURES_VIGNETTE_PHOTO_EDITOR: '/studio/features/vignette-photo-editor/',
  STUDIO_FEATURES_WATER_BOTTLE_LABEL_MAKER: '/studio/features/water-bottle-label-maker/',
  STUDIO_FEATURES_WATTPAD_COVER_MAKER: '/studio/features/wattpad-cover-maker/',
  STUDIO_FEATURES_WEEKLY_SCHEDULE_MAKER: '/studio/features/weekly-schedule-maker/',
  STUDIO_FEATURES_WINE_BOTTLE_LABEL_MAKER: '/studio/features/wine-bottle-label-maker/',
  STUDIO_FEATURES_WORKOUT_PLAN_CREATOR: '/studio/features/workout-plan-creator/',
  STUDIO_FEATURES_YEARBOOK_DESIGNER: '/studio/features/yearbook-designer/',
  STUDIO_FEATURES_ZOOM_BACKGROUND_DESIGNER: '/studio/features/zoom-background-designer/',
  STUDIO_FEATURES_AUTOMOTIVE_PHOTO_EDITOR: '/studio/features/automotive-photo-editor/',
  STUDIO_FEATURES_FACEBOOK_ADVERTISEMENT_CREATOR:
    '/studio/features/facebook-advertisement-creator/',
  STUDIO_FEATURES_CUSTOM_HOODIE_DESIGN_MAKER: '/studio/features/custom-hoodie-design-maker/',
  STUDIO_FEATURES_CUSTOM_SWEATSHIRT_DESIGN_MAKER:
    '/studio/features/custom-sweatshirt-design-maker/',
  STUDIO_FEATURES_CUSTOM_T_SHIRT_DESIGN_MAKER: '/studio/features/custom-t-shirt-design-maker/',
  STUDIO_FEATURES_DIGITAL_VISION_BOARD_MAKER: '/studio/features/digital-vision-board-maker/',
  STUDIO_FEATURES_EVENT_PROGRAM_MAKER: '/studio/features/event-program-maker/',
  STUDIO_FEATURES_MOOD_BOARD_CREATOR: '/studio/features/mood-board-creator/',
  STUDIO_FEATURES_PFP_MAKER: '/studio/features/pfp-maker/',
  STUDIO_FEATURES_PROPOSAL_MAKER: '/studio/features/proposal-maker/',
  STUDIO_FEATURES_QUOTE_MAKER: '/studio/features/quote-maker/',
  STUDIO_FEATURES_RAFFLE_TICKET_MAKER: '/studio/features/raffle-ticket-maker/',
  STUDIO_FEATURES_SEATING_CHART_MAKER: '/studio/features/seating-chart-maker/',
  STUDIO_FEATURES_SOCIAL_MEDIA_GRAPHICS_DESIGNER:
    '/studio/features/social-media-graphics-designer/',
  STUDIO_FEATURES_TICKET_MAKER: '/studio/features/ticket-maker/',
  STUDIO_FEATURES_TWITCH_OVERLAY_MAKER: '/studio/features/twitch-overlay-maker/',
  STUDIO_FEATURES_TWITCH_PANEL_MAKER: '/studio/features/twitch-panel-maker/',
  STUDIO_FEATURES_WEDDING_PROGRAM_MAKER: '/studio/features/wedding-program-maker/',
  STUDIO_FEATURES_WEDDING_SEATING_CHART_MAKER: '/studio/features/wedding-seating-chart-builder/',
  STUDIO_FEATURES_YOUTUBE_PROFILE_PICTURE_MAKER: '/studio/features/youtube-profile-picture-maker/',
  STUDIO_FEATURES_ACROSTIC_POEM_CREATOR: '/studio/features/acrostic-poem-creator/',
  STUDIO_FEATURES_AI_ERASE_AND_REPLACE: '/studio/features/ai-erase-and-replace/',
  STUDIO_FEATURES_AI_FILTER: '/studio/features/ai-filter/',
  STUDIO_FEATURES_AI_IMAGE_VARIATION_GENERATOR: '/studio/features/ai-image-variation-generator/',
  STUDIO_FEATURES_AI_MEME_GENERATOR: '/studio/features/ai-meme-generator/',
  STUDIO_FEATURES_AI_RESUME_BUILDER: '/studio/features/ai-resume-builder/',
  STUDIO_FEATURES_AI_SKETCH_RENDERING: '/studio/features/ai-sketch-rendering/',
  STUDIO_FEATURES_AI_TEXT_EFFECT_MAKER: '/studio/features/ai-text-effect-maker/',
  STUDIO_FEATURES_ANNIVERSARY_GREETING_CARDS_ONLINE:
    '/studio/features/anniversary-greeting-cards-online/',
  STUDIO_FEATURES_ANNOUNCEMENT_MAKER: '/studio/features/announcement-maker/',
  STUDIO_FEATURES_BACKGROUND_PICTURE_CREATOR: '/studio/features/background-picture-creator/',
  STUDIO_FEATURES_BADGE_MAKER: '/studio/features/badge-maker/',
  STUDIO_FEATURES_BAND_MERCH_MAKER: '/studio/features/band-merch-maker/',
  STUDIO_FEATURES_BARCODE_GENERATOR: '/studio/features/barcode-generator/',
  STUDIO_FEATURES_BIRTHDAY_FLYER_MAKER: '/studio/features/birthday-flyer-maker/',
  STUDIO_FEATURES_BMP_EDITOR: '/studio/features/bmp-editor/',
  STUDIO_FEATURES_BROCHURE_MAKER: '/studio/features/brochure-maker/',
  STUDIO_FEATURES_BUSINESS_WEBSITE_BUILDER: '/studio/features/business-website-builder/',
  STUDIO_FEATURES_CALENDAR_MAKER: '/studio/features/calendar-maker/',
  STUDIO_FEATURES_CHANGE_PHOTO_BACKGROUND: '/studio/features/change-photo-background/',
  STUDIO_FEATURES_CHORE_LIST_MAKER: '/studio/features/chore-list-maker/',
  STUDIO_FEATURES_CLASSROOM_SEATING_CHART_MAKER: '/studio/features/classroom-seating-chart-maker/',
  STUDIO_FEATURES_CREATE_INSTAGRAM_ADS: '/studio/features/create-instagram-ads/',
  STUDIO_FEATURES_CREATE_YOUR_OWN_BOOKLET: '/studio/features/create-your-own-booklet/',
  STUDIO_FEATURES_CUSTOM_CHRISTMAS_PHOTO_CARDS: '/studio/features/custom-christmas-photo-cards/',
  STUDIO_FEATURES_CUSTOM_GARMENT_LABEL_MAKER: '/studio/features/custom-garment-label-maker/',
  STUDIO_FEATURES_CUSTOM_GRADUATION_INVITATION_MAKER:
    '/studio/features/custom-graduation-invitation-maker/',
  STUDIO_FEATURES_CUSTOM_PHOTO_CALENDAR: '/studio/features/custom-photo-calendar/',
  STUDIO_FEATURES_CUSTOM_REAL_ESTATE_SIGN_MAKER: '/studio/features/custom-real-estate-sign-maker/',
  STUDIO_FEATURES_CUSTOM_WALLPAPER_MAKER: '/studio/features/custom-wallpaper-maker/',
  STUDIO_FEATURES_CUSTOMIZABLE_MAP_MAKER: '/studio/features/customizable-map-maker/',
  STUDIO_FEATURES_DESIGN_A_LETTERHEAD: '/studio/features/design-a-letterhead/',
  STUDIO_FEATURES_DISCOUNT_COUPON_GENERATOR: '/studio/features/discount-coupon-generator/',
  STUDIO_FEATURES_DOCUMENT_EDITOR: '/studio/features/document-editor/',
  STUDIO_FEATURES_DOCUMENT_MAKER: '/studio/features/document-maker/',
  STUDIO_FEATURES_EMAIL_SIGNATURE_GENERATOR: '/studio/features/email-signature-generator/',
  STUDIO_FEATURES_EPK_MAKER: '/studio/features/epk-maker/',
  STUDIO_FEATURES_EXCEL_TO_PDF: '/studio/features/excel-to-pdf/',
  STUDIO_FEATURES_FANTASY_FOOTBALL_LOGO_MAKER: '/studio/features/fantasy-football-logo-maker/',
  STUDIO_FEATURES_FANTASY_MAP_CREATOR: '/studio/features/fantasy-map-creator/',
  STUDIO_FEATURES_FAVICON_GENERATOR: '/studio/features/favicon-generator/',
  STUDIO_FEATURES_FLAG_MAKER: '/studio/features/flag-maker/',
  STUDIO_FEATURES_FLASHCARD_MAKER: '/studio/features/flashcard-maker/',
  STUDIO_FEATURES_FOOTBALL_LOGO_MAKER: '/studio/features/football-logo-maker/',
  STUDIO_FEATURES_FORM_BUILDER: '/studio/features/form-builder/',
  STUDIO_FEATURES_GIF_MEME_MAKER: '/studio/features/gif-meme-maker/',
  STUDIO_FEATURES_HAIKU_POEM_CREATOR: '/studio/features/haiku-poem-creator/',
  STUDIO_FEATURES_ICO_CONVERTER: '/studio/features/ico-converter/',
  STUDIO_FEATURES_ICON_MAKER: '/studio/features/icon-maker/',
  STUDIO_FEATURES_IMAGE_TO_TEXT_CONVERTER: '/studio/features/image-to-text-converter/',
  STUDIO_FEATURES_INSTAGRAM_GRID_MAKER: '/studio/features/instagram-grid-maker/',
  STUDIO_FEATURES_INSTAGRAM_POST_MOCKUP_GENERATOR:
    '/studio/features/instagram-post-mockup-generator/',
  STUDIO_FEATURES_INVOICE_GENERATOR: '/studio/features/invoice-generator/',
  STUDIO_FEATURES_JPG_COMPRESSOR: '/studio/features/jpg-photo-compressor/',
  STUDIO_FEATURES_JPG_CONVERTER: '/studio/features/jpg-converter/',
  STUDIO_FEATURES_JPG_EDITOR: '/studio/features/jpg-editor/',
  STUDIO_FEATURES_JPG_TO_WORD_CONVERTER: '/studio/features/jpg-to-word-converter/',
  STUDIO_FEATURES_LANDING_PAGE_MAKER: '/studio/features/landing-page-maker/',
  STUDIO_FEATURES_LOVE_POEM_CREATOR: '/studio/features/love-poem-creator/',
  STUDIO_FEATURES_MAKE_FILLABLE_PDF: '/studio/features/make-fillable-pdf/',
  STUDIO_FEATURES_MATH_WORKSHEET_MAKER: '/studio/features/math-worksheet-maker/',
  STUDIO_FEATURES_MEDIA_KIT_CREATOR: '/studio/features/media-kit-creator/',
  STUDIO_FEATURES_MEETING_MINUTES_GENERATOR: '/studio/features/meeting-minutes-generator/',
  STUDIO_FEATURES_MEMO_MAKER: '/studio/features/memo-maker/',
  STUDIO_FEATURES_MERGE_PDF: '/studio/features/combine-pdf/',
  STUDIO_FEATURES_MONOGRAM_MAKER: '/studio/features/monogram-maker/',
  STUDIO_FEATURES_NEWSLETTER_MAKER: '/studio/features/newsletter-maker/',
  STUDIO_FEATURES_ONLINE_SIGNATURE_GENERATOR: '/studio/features/online-signature-generator/',
  STUDIO_FEATURES_PACKING_LIST_GENERATOR: '/studio/features/packing-list-generator/',
  STUDIO_FEATURES_PAMPHLET_MAKER: '/studio/features/pamphlet-maker/',
  STUDIO_FEATURES_PDF_CONVERTER: '/studio/features/pdf-converter/',
  STUDIO_FEATURES_PDF_ERASE_PAGE: '/studio/features/remove-pages-from-pdf/',
  STUDIO_FEATURES_PDF_MAKER: '/studio/features/pdf-maker/',
  STUDIO_FEATURES_PDF_TO_EXCEL: '/studio/features/pdf-to-excel/',
  STUDIO_FEATURES_PDF_TO_PPT_CONVERTER: '/studio/features/pdf-to-ppt-converter/',
  STUDIO_FEATURES_PDF_TO_WORD_CONVERTER: '/studio/features/pdf-to-word-converter/',
  STUDIO_FEATURES_PHONE_MOCKUP_GENERATOR: '/studio/features/phone-mockup-generator/',
  STUDIO_FEATURES_PHONE_WALLPAPER_MAKER: '/studio/features/phone-wallpaper-maker/',
  STUDIO_FEATURES_PHOTO_EDITOR: '/studio/features/photo-editor/',
  STUDIO_FEATURES_PICTURE_MONTAGE_MAKER: '/studio/features/picture-montage-maker/',
  STUDIO_FEATURES_PNG_COMPRESSOR: '/studio/features/png-compressor/',
  STUDIO_FEATURES_PNG_EDITOR: '/studio/features/png-editor/',
  STUDIO_FEATURES_PNG_MAKER: '/studio/features/png-maker/',
  STUDIO_FEATURES_PNG_TO_ICO_CONVERTER: '/studio/features/png-to-ico-converter/',
  STUDIO_FEATURES_POEM_MAKER: '/studio/features/poem-maker/',
  STUDIO_FEATURES_PORTFOLIO_WEBSITE_MAKER: '/studio/features/portfolio-website-maker/',
  STUDIO_FEATURES_PPT_TO_PDF_CONVERTER: '/studio/features/ppt-to-pdf-converter/',
  STUDIO_FEATURES_PREGNANCY_ANNOUNCEMENT: '/studio/features/pregnancy-announcement/',
  STUDIO_FEATURES_PROMO_CODE_GENERATOR: '/studio/features/promo-code-generator/',
  STUDIO_FEATURES_QR_CODE_GENERATOR: '/studio/features/qr-code-generator/',
  STUDIO_FEATURES_REPORT_GENERATOR: '/studio/features/report-generator/',
  STUDIO_FEATURES_RESIZE_IMAGES: '/studio/features/resize-images/',
  STUDIO_FEATURES_SHARE_FILES_ONLINE: '/studio/features/share-files-online/',
  STUDIO_FEATURES_SHIPPING_LABEL_MAKER: '/studio/features/shipping-label-maker/',
  STUDIO_FEATURES_SNAPCHAT_GEOFILTER_MAKER: '/studio/features/snapchat-geofilter-maker/',
  STUDIO_FEATURES_SOCCER_LOGO_MAKER: '/studio/features/soccer-logo-maker/',
  STUDIO_FEATURES_SPORTS_TEAM_LOGO_MAKER: '/studio/features/sports-team-logo-maker/',
  STUDIO_FEATURES_STUDY_SCHEDULE_BUILDER: '/studio/features/study-schedule-builder/',
  STUDIO_FEATURES_SURVEY_MAKER: '/studio/features/survey-maker/',
  STUDIO_FEATURES_SVG_COMPRESSOR: '/studio/features/svg-optimizer/',
  STUDIO_FEATURES_TEXT_TO_GIF_MAKER: '/studio/features/text-to-gif-maker/',
  STUDIO_FEATURES_THANKSGIVING_CARD_MAKER: '/studio/features/thanksgiving-card-maker/',
  STUDIO_FEATURES_TIFF_IMAGE_EDITOR: '/studio/features/tiff-image-editor/',
  STUDIO_FEATURES_TSHIRT_LOGO_DESIGNER: '/studio/features/tshirt-logo-designer/',
  STUDIO_FEATURES_WEBP_COMPRESSOR: '/studio/features/webp-compressor/',
  STUDIO_FEATURES_WEBSITE_BUILDER: '/studio/features/website-builder/',
  STUDIO_FEATURES_WEBSITE_PAGE_MOCKUP: '/studio/features/website-page-mockup/',
  STUDIO_FEATURES_WHATSAPP_STATUS_MAKER: '/studio/features/whatsapp-status-maker/',
  STUDIO_FEATURES_WINDOW_DECAL_MAKER: '/studio/features/window-decal-maker/',
  STUDIO_FEATURES_WORD_TO_JPG_CONVERTER: '/studio/features/word-to-jpg-converter/',
  STUDIO_FEATURES_WORD_TO_PDF_CONVERTER: '/studio/features/word-to-pdf-converter/',
  STUDIO_FEATURES_WORKSHEET_MAKER: '/studio/features/worksheet-maker/',
  STUDIO_FEATURES_YOUTUBE_MERCH_MAKER: '/studio/features/youtube-merch-maker/',
  STUDIO_FEATURES_COMBINE_PDF: '/studio/features/combine-pdf/',
  STUDIO_FEATURES_SPLIT_PDF: '/studio/features/split-pdf-document/',
  STUDIO_FEATURES_UNPIXELATE_IMAGE: '/studio/features/unpixelate-image/',
  STUDIO_FEATURES_ADD_BORDER_TO_PICTURE: '/studio/features/add-border-to-picture/',
  STUDIO_FEATURES_ADD_LOGO_TO_PHOTO: '/studio/features/add-logo-to-photo/',
  STUDIO_FEATURES_ADD_SANTA_CHRISTMAS_HAT_TO_PHOTO:
    '/studio/features/add-santa-christmas-hat-to-photo/',
  STUDIO_FEATURES_ADD_STICKERS_TO_PHOTO: '/studio/features/add-stickers-to-photo/',
  STUDIO_FEATURES_ADD_WHITE_BACKGROUND_TO_PHOTO: '/studio/features/add-white-background-to-photo/',
  STUDIO_FEATURES_AI_PHOTO_EDITING: '/studio/features/ai-photo-editing/',
  STUDIO_FEATURES_AI_PHOTO_RETOUCHING: '/studio/features/ai-photo-retouching/',
  STUDIO_FEATURES_AI_SELFIE_GENERATOR: '/studio/features/ai-selfie-generator/',
  STUDIO_FEATURES_AI_WATERMARK_REMOVER: '/studio/features/ai-watermark-remover/',
  STUDIO_FEATURES_BLEND_TWO_PHOTOS_TOGETHER: '/studio/features/blend-two-photos-together/',
  STUDIO_FEATURES_BLUR_FACE_IN_PHOTO: '/studio/features/blur-face-in-photo/',
  STUDIO_FEATURES_CARTOON_CHARACTER_MAKER: '/studio/features/cartoon-character-maker/',
  STUDIO_FEATURES_CLEANUP_PICTURES: '/studio/features/cleanup-pictures/',
  STUDIO_FEATURES_COLOR_PHOTO_TO_BLACK_AND_WHITE:
    '/studio/features/color-photo-to-black-and-white/',
  STUDIO_FEATURES_COLORIZE_PHOTO: '/studio/features/colorize-photo/',
  STUDIO_FEATURES_DENOISE_IMAGE: '/studio/features/denoise-image/',
  STUDIO_FEATURES_DRAW_ON_PHOTOS: '/studio/features/draw-on-photos/',
  STUDIO_FEATURES_EDIT_TEXT_IN_IMAGE: '/studio/features/edit-text-in-image/',
  STUDIO_FEATURES_EYE_COLOR_CHANGER: '/studio/features/eye-color-changer/',
  STUDIO_FEATURES_FACE_CUT_OUT_TOOL: '/studio/features/face-cut-out-tool/',
  STUDIO_FEATURES_FADE_PICTURE_EFFECT: '/studio/features/fade-picture-effect/',
  STUDIO_FEATURES_GLITCH_IMAGE_EFFECT: '/studio/features/glitch-image-effect/',
  STUDIO_FEATURES_HEART_FILTER: '/studio/features/heart-filter/',
  STUDIO_FEATURES_HEIC_TO_PNG_CONVERTER: '/studio/features/heic-to-png-converter/',
  STUDIO_FEATURES_IMAGE_BRIGHTENER: '/studio/features/image-brightener/',
  STUDIO_FEATURES_IMAGE_SPLITTER: '/studio/features/image-splitter/',
  STUDIO_FEATURES_IMAGE_ZOOMER: '/studio/features/image-zoomer/',
  STUDIO_FEATURES_INVERT_IMAGE_COLORS: '/studio/features/invert-image-colors/',
  STUDIO_FEATURES_MAKE_IMAGE_SQUARE: '/studio/features/make-image-square/',
  STUDIO_FEATURES_MAKEUP_PHOTO_EDITOR: '/studio/features/makeup-photo-editor/',
  STUDIO_FEATURES_MOTION_BLUR_EFFECT: '/studio/features/motion-blur-effect/',
  STUDIO_FEATURES_ONLINE_FACE_EDITOR: '/studio/features/online-face-editor/',
  STUDIO_FEATURES_ONLINE_PHOTO_FRAME_EDITOR: '/studio/features/online-photo-frame-editor/',
  STUDIO_FEATURES_PHOTO_BLEMISH_REMOVER: '/studio/features/photo-blemish-remover/',
  STUDIO_FEATURES_PHOTO_DATE_STAMPER: '/studio/features/photo-date-stamper/',
  STUDIO_FEATURES_PHOTO_GRAIN_FILTER: '/studio/features/photo-grain-filter/',
  STUDIO_FEATURES_PHOTO_TEETH_WHITENER: '/studio/features/photo-teeth-whitener/',
  STUDIO_FEATURES_PHOTO_TO_DRAWING: '/studio/features/photo-to-drawing/',
  STUDIO_FEATURES_PIXELATE_IMAGE: '/studio/features/pixelate-image/',
  STUDIO_FEATURES_PNG_COLOR_CHANGER: '/studio/features/png-color-changer/',
  STUDIO_FEATURES_RED_EYE_REMOVER_FROM_PHOTO: '/studio/features/red-eye-remover-from-photo/',
  STUDIO_FEATURES_REMOVE_FILTER_FROM_PHOTO: '/studio/features/remove-filter-from-photo/',
  STUDIO_FEATURES_REMOVE_GLARE_FROM_PHOTO: '/studio/features/remove-glare-from-photo/',
  STUDIO_FEATURES_SCALE_IMAGE: '/studio/features/scale-image/',
  STUDIO_FEATURES_SEPIA_TONE_PHOTO_FILTER: '/studio/features/sepia-tone-photo-filter/',
  STUDIO_FEATURES_SHADOW_IN_PICTURE: '/studio/features/shadow-in-picture/',
  STUDIO_FEATURES_SHAPE_PICTURE: '/studio/features/shape-picture/',
  STUDIO_FEATURES_STRAIGHTEN_PHOTO_ONLINE: '/studio/features/straighten-photo-online/',
  STUDIO_FEATURES_SVG_TO_PNG_CONVERTER: '/studio/features/svg-to-png-converter/',
  STUDIO_FEATURES_TINT_PICTURE: '/studio/features/tint-picture/',
  STUDIO_FEATURES_TRANSPARENT_SIGNATURE: '/studio/features/transparent-signature/',
  STUDIO_FEATURES_TURN_PHOTO_INTO_LINE_DRAWING: '/studio/features/turn-photo-into-line-drawing/',
  STUDIO_FEATURES_TURN_PHOTO_INTO_SILHOUETTE: '/studio/features/turn-photo-into-silhouette/',
  STUDIO_FEATURES_TURN_PHOTO_INTO_WATERCOLOR: '/studio/features/turn-photo-into-watercolor/',
  STUDIO_FEATURES_VIRTUAL_TRY_ON_HAIR_COLOR: '/studio/features/virtual-try-on-hair-color/',
  STUDIO_FEATURES_WEBP_TO_PNG_CONVERTER: '/studio/features/webp-to-png-converter/',
  STUDIO_PARTNERS_GELATO: '/studio/partners/gelato/',
  STUDIO_PARTNERS_PRINTFUL: '/studio/partners/printful/',
  STUDIO_PARTNERS_PRINTIFY: '/studio/partners/printify/',
  HELP_CENTER: 'https://help.creativefabrica.com/',
  POD: `${rootPath}/pod/`,
  SUBSCRIPTION: `/subscription/`,
  TOC: `${rootPath}/terms-of-service/`,
  POC: `${rootPath}/privacy-policy/`,
  AFFILIATES: `${rootPath}/affiliates/`,
  CANCELLATION_POLICY: `${rootPath}/cancellation-policy/`,
  SINGLE_SALES_LICENSE: `${rootPath}/single-sales-license/`,
  ABOUT: '/about/',
  THE_ARTISTRY: `${rootPath}/the-artistry/`,
  STUDIO_TOOL: `${studioRootPath}/`,
  STUDIO_TOOL_PROJECTS: `${studioRootPath}/studio/projects/`,
  STUDIO_FONT_GENERATOR: `${studioRootPath}/font-generator/`,
  STUDIO_TOOL_FLOW: `${studioRootPath}/flow/`,
  STUDIO_TOOL_TRANSFER: `${studioRootPath}/transfer/`,
  STUDIO_TOOL_CREATE: `${studioRootPath}/studio/create/`,
  STUDIO_TOOL_VECTORIZER: `${studioRootPath}/vectorizer/`,
  STUDIO_TOOL_BACKGROUND_REMOVER: `${studioRootPath}/background-remover/`,
  STUDIO_TOOL_UPSCALER: `${studioRootPath}/image-upscaler/`,
  STUDIO_TOOL_FILE_CONVERTER: `${studioRootPath}/file-converter/`,
  STUDIO_TOOL_LOGO_CREATOR: `${studioRootPath}/logo-creator/`,
  STUDIO_TOOL_IMAGE_COMPRESSOR: `${studioRootPath}/image-compressor/`,
  STUDIO_TOOL_FONT_GENERATOR: `${studioRootPath}/font-generator/`,
  STUDIO_TOOL_AI_IMAGE_EDITOR: `${studioRootPath}/ai-image-editor/`,
  STUDIO_TOOL_AI_MUSIC_GENERATOR: `${studioRootPath}/ai-music-generator/`,
  STUDIO_TOOL_AI_VIDEO_GENERATOR: `${studioRootPath}/ai-video-generator/`,
  STUDIO_TOOL_AI_QUOTE_GENERATOR: `${studioRootPath}/ai-quote-generator/`,
  STUDIO_TOOL_AI_DESIGN_REVIEWER: `${studioRootPath}/ai-design-reviewer/`,
  STUDIO_COINS: `${studioRootPath}/coins/`,
  STUDIO_COINS_TRANSACTIONS: `${studioRootPath}/coins/transactions/`,
  STUDIO_TOOL_LP_PICTURE_BACKGROUND_REMOVER: `${studioRootPath}/background-remover/lp/picture-background-remover/`,
  STUDIO_TOOL_LP_IMAGE_BACKGROUND_REMOVER: `${studioRootPath}/background-remover/lp/remove-background-from-image/`,
  STUDIO_TOOL_LP_BACKGROUND_ERASER: `${studioRootPath}/background-remover/lp/background-eraser/`,
  STUDIO_TOOL_LP_FREE_BACKGROUND_REMOVER: `${studioRootPath}/background-remover/lp/free-background-remover/`,
  STUDIO_TOOL_LP_BACKDROP_REMOVER: `${studioRootPath}/background-remover/lp/backdrop-remover/`,
  STUDIO_TOOL_LP_PHOTO_BACKGROUND: `${studioRootPath}/background-remover/lp/photo-background/`,
  FANS: isProduction
    ? 'https://fans.creativefabrica.com/'
    : 'https://fans-staging.creativefabrica.com/',
  HIRING: 'https://careers.creativefabrica.com/',
  PRIVACY_POLICY: 'https://www.iubenda.com/privacy-policy/24976076/cookie-policy',
  FREE_TRIAL: '/p/free-trial/',
  PARTNERS_SISER: '/siser/',
  PARTNERS_SCAL: '/scal/',
  PARTNERS_THEMAKERSCHEST: '/themakerschest/',
  PARTNERS_HEAT_TRANSFER_WAREHOUSE: '/heat-transfer-warehouse/',
  PARTNERS_XTOOL: '/xtool/',
  HALLOWEEN: '/halloween/',
  HALLOWEEN_TERMS_AND_CONDITIONS: '/halloween/terms-and-conditions/',
  SEARCH: '/search/',
  SPARK_ART_GENERATOR: '/spark/tools/art-generator/',
  SPARK_PATTERNS: '/spark/tools/pattern-generator/',
  SPARK_TEXT_GENERATOR: '/spark/tools/text-generator/',
  SPARK_COLORING_PAGE_GENERATOR: '/spark/tools/coloring-page-generator/',
  SPARK_CRYSTALLINE: '/spark/tools/crystalline/',
  SPARK_SKETCH_GENERATOR: '/spark/tools/sketch-generator/',
  SPARK_IMAGEMIX: '/spark/tools/imagemix',
  DAILY_GIFTS: '/daily-gifts/',
  DISCOUNT_DEALS: '/discount-deals/',

  CLUBHOUSE: '/clubhouse/',
  RHINESTONES: '/clubhouse/rhinestones/',
  PAPER_CRAFTS: '/clubhouse/paper-crafts/',
  XTOOL: '/clubhouse/xtool/',
  SISER: '/clubhouse/siser/',
  CHRISTMAS: '/clubhouse/christmas/',
  KIDS_CRAFTS: '/clubhouse/kids-crafts/',
  KNITTING: '/clubhouse/knitting/',
  CLUBHOUSE_HALLOWEEN: '/clubhouse/halloween/',
  SELLING_ON_ETSY: '/clubhouse/selling-on-etsy/',
  PRINT_ON_DEMAND: '/clubhouse/print-on-demand/',
  WEDDINGS: '/clubhouse/weddings/',

  // Landing Pages
  COMMERCIAL_USE_GUIDE: '/commercial-use-guide/',
  TRANSFER: '/transfer/',
  LICENSE: '/license/',
  PROMO_YEARLY: '/promo/yearly/',
  ADLP: '/adlp/',

  // Cricut Microsite
  CRICUT: '/clubhouse/cricut/',
  CRICUT_ASSETS: '/tag/cricut/',
  CRICUT_CLASSES: '/subscriptions/classes/cricut/',
  CRICUT_GUIDE: '/the-ultimate-cricut-guide/',

  // Content API
  PROD: '/prod/',
  STOCKPHOTOS: '/stockphotos/',
  STOCKPHOTOS_SEARCH: '/stockphotos/search/',
  STOCKPHOTOS_LICENCE: '/stockphoto-license/',
  SUBSCRIPTION_LICENCE: '/subscription-license/',
  SINGLE_SALES_LICENCE: '/single-sales-license/',
  CF_PREMIUM_LICENCE: '/cf-premium-license/',
  ENTERPRISE_LICENCE: '/enterprise-license/',
  LICENSE_VALIDATOR: '/license-key-validator/',
  STOCKPHOTOS_POPULAR: '/stockphotos/popular/',
  PNG: '/png/',
  PNG_SEARCH: '/png/search/',
  PNG_POPULAR: '/png/popular/',
  KAWAII: '/kawaii/',
  KAWAII_SEARCH: '/kawaii/search/',
  KAWAII_POPULAR: '/kawaii/popular/',
  MOCKUPS: '/mockups/',
  MOCKUPS_SEARCH: '/mockups/search/',
  MOCKUPS_POPULAR: '/mockups/popular/',
  BACKGROUNDS: '/backgrounds/',
  BACKGROUNDS_SEARCH: '/backgrounds/search/',
  BACKGROUNDS_POPULAR: '/backgrounds/popular/',
  SKETCHES: '/sketches/',
  SKETCHES_SEARCH: '/sketches/search/',
  SKETCHES_POPULAR: '/sketches/popular/',
  PATTERNS: '/patterns/',
  PATTERNS_SEARCH: '/patterns/search/',
  PATTERNS_POPULAR: '/patterns/popular/',
  BORDERS_AND_CORNERS: '/borders-and-corners/',
  BORDERS_AND_CORNERS_SEARCH: '/borders-and-corners/search/',
  BORDERS_AND_CORNERS_POPULAR: '/borders-and-corners/popular/',
  FRAMES: '/frames/',
  FRAMES_SEARCH: '/frames/search/',
  FRAMES_POPULAR: '/frames/popular/',
  FREEBIES: '/freebies/',
  FREEBIES_PAGINATION: '/freebies/page/',
  CARTOONS: '/cartoons/',
  CARTOONS_SEARCH: '/cartoons/search/',
  CARTOONS_POPULAR: '/cartoons/popular/',
  TEXTURES: '/textures/',
  TEXTURES_SEARCH: '/textures/search/',
  TEXTURES_POPULAR: '/textures/popular/',
  SILHOUETTES: '/silhouettes/',
  SILHOUETTES_SEARCH: '/silhouettes/search/',
  SILHOUETTES_POPULAR: '/silhouettes/popular/',
  DRAWINGS: '/drawings/',
  DRAWINGS_SEARCH: '/drawings/search/',
  DRAWINGS_POPULAR: '/drawings/popular/',
  CLIP_ART: '/clip-art/',
  CLIP_ART_SEARCH: '/clip-art/search/',
  CLIP_ART_POPULAR: '/clip-art/popular/',
  QUOTES: '/quotes/',
  QUOTES_SEARCH: '/quotes/search/',
  QUOTES_POPULAR: '/quotes/popular/',
  STICKERS: '/stickers/',
  STICKERS_SEARCH: '/stickers/search/',
  STICKERS_POPULAR: '/stickers/popular/',
  SVGS: '/svgs/',
  SVGS_SEARCH: '/svgs/search/',
  SVGS_POPULAR: '/svgs/popular/',
  COLORING_PAGES: '/coloring-pages/',
  COLORING_PAGES_SEARCH: '/coloring-pages/search/',
  COLORING_PAGES_POPULAR: '/coloring-pages/popular/',
  B_FREE_TRIAL: '/b/free-trial/',
  B_FREE_TRIAL_YEARLY: '/b/free-trial-yearly/',
  B_FREE_TRIAL_AISTUDIO: '/b/free-trial-aistudio/',
  B_AISTUDIO: '/b/aistudio/',
  B_YEARLY: '/b/yearly/',
  B_YEARLY_PROMO: '/b/yearly-promo/',
  B_MONTHLY: '/b/monthly/',
  CONFIRMATION_1V1: '/confirmation/1v1/',
  CONFIRMATION_2V1: '/confirmation/2v1/',
  CONFIRMATION_3V1: '/confirmation/3v1/',
  CONFIRMATION_1V2: '/confirmation/1v2/',
  CONFIRMATION_1V3: '/confirmation/1v3/',
  CONFIRMATION_2V2: '/confirmation/2v2/',
  CONFIRMATION_3V2: '/confirmation/3v2/',
  FONTS: `${rootPath}/fonts/`,
  FONTS_SCRIPT_FONTS: `${rootPath}/fonts/script-fonts/`,
  FONTS_DISPLAY_FONTS: `${rootPath}/fonts/display-fonts/`,
  FONTS_SANS_SERIF_FONTS: `${rootPath}/fonts/sans-serif-fonts/`,
  FONTS_SERIF_FONTS: `${rootPath}/fonts/serif-fonts/`,
  FONTS_BLACKLETTER_FONTS: `${rootPath}/fonts/blackletter-fonts/`,
  FONTS_SLAB_SERIF_FONTS: `${rootPath}/fonts/slab-serif-fonts/`,
  FONTS_DECORATIVE_FONTS: `${rootPath}/fonts/decorative-fonts/`,
  FONTS_DINGBATS_FONTS: `${rootPath}/fonts/dingbats-fonts/`,
  FONTS_COLORFUL_FONTS: `${rootPath}/fonts/color-fonts/`,
  FONTS_WEDDING_FONTS: `${rootPath}/fonts/wedding-fonts/`,
  FONTS_RELATIVE_PATH: `/fonts/`,
  THREEDSVG: `${rootPath}/3d-svg/`,
  THREEDPRINTING: `${rootPath}/3d-printing/`,
  LASERCUTTING: `${rootPath}/laser-cutting/`,
  SUBSCRIPTIONS_THREEDSVG: `${rootPath}/subscriptions/3d-svg/`,
  SUBSCRIPTIONS_FONTS: `${rootPath}/subscriptions/fonts/`,
  SUBSCRIPTIONS_GRAPHICS: `${rootPath}/subscriptions/graphics/`,
  SUBSCRIPTIONS_BUNDLES: `${rootPath}/subscriptions/bundles/`,
  SUBSCRIPTIONS_CRAFTS: `${rootPath}/subscriptions/crafts/`,
  EMBROIDERY: `${rootPath}/embroidery/`,
  SUBSCRIPTIONS_EMBROIDERY: `${rootPath}/subscriptions/embroidery/`,
  GRAPHICS: '/graphics/',
  CATEGORIES_PAGINATION_URL: (category: string, page: number) =>
    `/subscriptions/${category}/page/${page}/`,
  NEEDLEWORK: `${rootPath}/subscriptions/graphics/needle-arts/`,
  CRAFTS: '/crafts/',
  BUNDLES: `${rootPath}/bundles/`,
  LASER_CUTTING: `${rootPath}/laser-cutting/`,
  CLASSES: `${rootPath}/classes/`,
  MASTERFEED: `${rootPath}/masterfeed/`,
  GRAPHICS_PRINT_TEMPLATES: `${rootPath}/subscriptions/graphics/graphic-templates/print-templates/`,
  GRAPHICS_CRAFTS_GRAPHICS: `${rootPath}/subscriptions/graphics/crafts-graphics/`,
  GRAPHICS_MOCKUPS: `${rootPath}/subscriptions/graphics/product-mockups/`,
  GRAPHICS_BACKGROUNDS: `${rootPath}/subscriptions/graphics/backgrounds/`,

  PRODUCT: `${rootPath}/product/`,

  // Social feed (masterfeed — direct access only)
  SOCIAL_FEED_YOUR_FEED: '/masterfeed/',
  SOCIAL_FEED_DISCOVERY_FEED: '/masterfeed/',
  SOCIAL_FEED_NOTIFICATIONS: '/masterfeed/notifications/',
  SOCIAL_FEED_SAVED_POSTS: '/masterfeed/saved/',
  SOCIAL_FEED_CRAFTER: '/crafter/',
  SOCIAL_FEED_REDIRECT_SCREEN: `${rootPath}/masterfeed/redirect`,

  // Social feed (curated — primary /feed/ route)
  SOCIAL_CURATED_FEED_YOUR_FEED: '/feed/',
  SOCIAL_CURATED_FEED: '/feed/',
  SOCIAL_CURATED_FEED_NOTIFICATIONS: '/feed/notifications/',
  SOCIAL_CURATED_FEED_SAVED: '/feed/saved/',
  SOCIAL_CURATED_FEED_CRAFTER: '/crafter/',
  SOCIAL_CURATED_FEED_REDIRECT: `${rootPath}/feed/redirect`,

  // Tools
  TOOLS: '/tools/',
  TOOLS_BACKGROUND_REMOVER: '/tools/background-remover/',
  TOOLS_3D_PRINT_GENERATOR: '/tools/3d-print-generator/',
  TOOLS_VECTORIZER: '/tools/vectorizer/',
  TOOLS_LOGO_CREATOR: '/tools/logo-creator/',
  TOOLS_AI_SVG_GENERATOR: '/tools/ai-svg-generator/',
  TOOLS_AI_PNG_GENERATOR: '/tools/ai-png-generator/',
  TOOLS_AI_FONT_GENERATORS: '/tools/ai-font-generators/',
  TOOLS_FONT_GENERATOR: '/tools/font-generator/',
  TOOLS_AI_FONT_GENERATOR: '/tools/ai-font-generator/',
  TOOLS_FANCY_FONT_GENERATOR: '/tools/fancy-font-generator/',
  TOOLS_WEBDINGS_TRANSLATOR: '/tools/webdings-translator/',
  TOOLS_GLITCH_TEXT_GENERATOR: '/tools/glitch-text-generator/',
  TOOLS_SMALL_TEXT_GENERATOR: '/tools/small-text-generator/',
  TOOLS_CURSED_TEXT_GENERATOR: '/tools/cursed-text-generator/',
  TOOLS_BOLD_TEXT_GENERATOR: '/tools/bold-text-generator/',
  TOOLS_ZALGO_TEXT_GENERATOR: '/tools/zalgo-text-generator/',
  TOOLS_INSTAGRAM_FONTS_GENERATOR: '/tools/instagram-fonts-generator/',
  TOOLS_COOL_FONTS_GENERATOR: '/tools/cool-fonts-generator/',
  TOOLS_CREEPY_TEXT_GENERATOR: '/tools/creepy-text-generator/',
  TOOLS_CURSIVE_FONT_GENERATOR: '/tools/cursive-font-generator/',
  TOOLS_ITALICS_TEXT_GENERATOR: '/tools/italics-text-generator/',
  TOOLS_WINGDINGS_TRANSLATOR: '/tools/wingdings-translator/',
  TOOLS_UPSIDE_DOWN_TEXT_GENERATOR: '/tools/upside-down-text-generator/',
  TOOLS_GOTHIC_FONT_GENERATOR: '/tools/gothic-font-generator/',
  TOOLS_AESTHETIC_FONTS_GENERATOR: '/tools/aesthetic-fonts-generator/',
  TOOLS_TWITTER_FONTS_GENERATOR: '/tools/twitter-fonts-generator/',
  TOOLS_DISCORD_FONTS_GENERATOR: '/tools/discord-fonts-generator/',
  TOOLS_STRIKE_THROUGH_TEXT_GENERATOR: '/tools/strike-through-text-generator/',
  TOOLS_CURVE_TEXT_GENERATOR: '/tools/curve-text-generator/',
  TOOLS_FACEBOOK_FONTS_GENERATOR: '/tools/facebook-fonts-generator/',
  TOOLS_BIG_TEXT_GENERATOR: '/tools/big-text-generator/',
  TOOLS_STYLISH_TEXT_GENERATOR: '/tools/stylish-text-generator/',
  TOOLS_TYPEWRITER_FONT_GENERATOR: '/tools/typewriter-font-generator/',
  TOOLS_SPECIAL_TEXT_GENERATOR: '/tools/special-text-generator/',
  TOOLS_VAPORWAVE_TEXT_GENERATOR: '/tools/vaporwave-text-generator/',
  TOOLS_MIRROR_TEXT_GENERATOR: '/tools/mirror-text-generator/',
  TOOLS_HACKED_TEXT_GENERATOR: '/tools/hacked-text-generator/',
  TOOLS_BUBBLE_WORDS_GENERATOR: '/tools/bubble-words-generator/',
  TOOLS_GREEK_TEXT_GENERATOR: '/tools/greek-text-generator/',
  TOOLS_CALLIGRAPHY_FONT_GENERATOR: '/tools/calligraphy-font-generator/',
  TOOLS_ASCII_ART_GENERATOR: '/tools/ascii-art-generator/',
  TOOLS_UNDERLINE_TEXT_GENERATOR: '/tools/underline-text-generator/',
  TOOLS_TIKTOK_FONT_GENERATOR: '/tools/tiktok-font-generator/',
  TOOLS_SCARY_TEXT_GENERATOR: '/tools/scary-text-generator/',
  TOOLS_NUMBER_FONT_GENERATOR: '/tools/number-font-generator/',
  TOOLS_WIDE_TEXT_GENERATOR: '/tools/wide-text-generator/',
  TOOLS_BLOCK_FONT_GENERATOR: '/tools/block-font-generator/',
  TOOLS_FUTURISTIC_FONT_GENERATOR: '/tools/futuristic-font-generator/',

  TOOLS_FONTCLOUD: '/fontcloud/',
  TOOLS_SHAPECLOUD: '/shapecloud/',
  TOOLS_WEBFONT_CONVERTER: '/webfont-generator/',

  FREEBIES_FONTS: '/freebies/free-fonts/',
  LICENSE_KEYS_OVERVIEW: `${rootPath}/my-account/license-keys-overview/`,
  LOGIN: '/login/',
  // My Account
  MY_ACCOUNT: myAccountPath,
  MY_ACCOUNT_SUBSCRIPTION_CANCELLED: `${myAccountPath}subscription-cancelled/`,
  MY_ACCOUNT_REACTIVATE_SUBSCRIPTION: `${myAccountPath}reactivate-subscription-action/`,
  MY_ACCOUNT_FAVORITES: `/my-favorites/`,
  FOLLOWING: `${rootPath}/following/`,
  MY_ACCOUNT_EDIT_ACCOUNT: `${myAccountPath}edit-account/`,
  MY_ACCOUNT_PAYMENT_METHODS: `${myAccountPath}payment-methods/`,
  MY_ACCOUNT_SHIPPING_ADDRESS: `${myAccountPath}shipping-address/`,
  MY_ACCOUNT_CLASSES: `${myAccountPath}my-classes/`,
  MY_ACCOUNT_ARTICLES: `${myAccountPath}my-articles/`,
  MY_ACCOUNT_PROFILE: `${myAccountPath}my-profile/`,
  MY_ACCOUNT_SETTINGS: `${myAccountPath}my-profile/settings/`,
  MY_ACCOUNT_LICENSES: `${myAccountPath}license-keys-overview/`,
  MY_ACCOUNT_SOCIAL_LOGIN: `${myAccountPath}social-accounts/`,
  MY_ACCOUNT_ORDERS: `${myAccountPath}orders/`,
  MY_ACCOUNT_NOTIFICATION_SETTINGS: `${myAccountPath}email-settings/`,
  MY_ACCOUNT_BILLING_DETAILS: `${myAccountPath}billing-details/`,
  MY_ACCOUNT_SUBSCRIPTIONS: `${myAccountPath}subscriptions/`,
  MY_ACCOUNT_CANCEL_SUBSCRIPTION: `${myAccountPath}cancel-subscription/`,
  MY_ACCOUNT_VIEW_SUBSCRIPTION: `${myAccountPath}view-subscription/`,
  MY_ACCOUNT_VIEW_ORDER: `${myAccountPath}view-order/`,
  MY_ACCOUNT_ADD_FONT: `/dashboard/product-add/font/`,
  MY_ACCOUNT_ADD_GRAPHIC: `/dashboard/product-add/graphic/`,
  MY_ACCOUNT_ADD_EMBROIDERY: `/dashboard/product-add/embroidery/`,
  MY_ACCOUNT_DELETE_ACCOUNT: `${myAccountPath}delete-account/`,
  MY_ACCOUNT_ACTIVITY: `${myAccountPath}activity/`,
  MY_ACCOUNT_MANAGE_SUBSCRIPTION: `${myAccountPath}manage-subscription/`,
  ENABLE_NOTIFICATIONS: '/enable-notifications/',
  LOGOUT: `${myAccountPath}customer-logout/`,
  DASHBOARD: `/dashboard/`,
  AFFILIATE_AREA: `/affiliate-area/?tab=urls`,
  REFERRAL_URL_GENERATOR: `/affiliate-area/referral-url-generator/`,
  AFFILIATE_AREA_STATS: `/affiliate-area/?tab=stats`,
  AFFILIATE_AREA_REFERRALS: `/affiliate-area/?tab=referrals`,
  AFFILIATE_AREA_VISITS: `/affiliate-area/?tab=visits`,
  AFFILIATE_AREA_CREATIVES: `/affiliate-area/?tab=creatives`,
  AFFILIATE_AREA_SETTINGS: `/affiliate-area/?tab=settings`,
  OPEN_STORE: '/open-store/',

  ADMIN_DASHBOARD_BY_USER_ID: `/admin-dashboard/admin-manage/support`,
  CHRISTMAS_IN_JULY: '/christmas-in-july/',
  SUBSCRIPTION_LICENSE: '/subscription-license/',
  SUBSCRIPTION_LICENSE_1v2: '/subscription-license-v1-2/',
  SUBSCRIPTION_LICENSE_1v3: '/subscription-license/v1-3/',
}

export const AppRoutesParameterized = {
  CLUBHOUSE: (clubhouseSlug: string) => `/clubhouse/${clubhouseSlug}/`,
  CLUBHOUSE_FILE: (fileSlug: string, clubhouseSlug: string) =>
    `/clubhouse/${clubhouseSlug}/files/${fileSlug}/`,
  CLUBHOUSE_QUIZZES: (clubhouseSlug: string) => `/clubhouse/${clubhouseSlug}/quizzes/`,
  CLUBHOUSE_QUIZ: (clubhouseSlug: string, quizSlug: string) =>
    `/clubhouse/${clubhouseSlug}/quizzes/${quizSlug}/`,
  CLUBHOUSE_SEARCH_RESULTS: (search?: string) => `/clubhouse/${search ? `?search=${search}` : ''}`,
  CLUBHOUSE_ASK_QUESTION_DETAILS: (
    clubhouseSlug: string,
    topicSlug: string,
    questionSlug: string,
  ) => `/clubhouse/${clubhouseSlug}/ask/${topicSlug}/${questionSlug}/`,
  CLUBHOUSE_PROJECT: (clubhouseSlug: string, postSlug: string) =>
    `/clubhouse/${clubhouseSlug}/inspiration/projects/${postSlug}/`,
  CLUBHOUSE_ASK_TOPIC_FEED: (clubhouseSlug: string, topicSlug: string) =>
    `/clubhouse/${clubhouseSlug}/ask/${topicSlug}/`,
  CLUBHOUSE_DISCUSSIONS: (clubhouseSlug: string) => `/clubhouse/${clubhouseSlug}/discussions/`,
  CLUBHOUSE_DISCUSSIONS_TOPICS: (clubhouseSlug: string, topicSlug: string) =>
    `/clubhouse/${clubhouseSlug}/discussions/${topicSlug}/`,
  CLUBHOUSE_DISCUSSION_DETAILS: (
    clubhouseSlug: string,
    topicSlug: string,
    discussionSlug: string,
  ) => `/clubhouse/${clubhouseSlug}/discussions/${topicSlug}/${discussionSlug}`,
  CLUBHOUSE_START_DICUSSION: (clubhouseSlug: string, topicSlug: string) =>
    `/clubhouse/${clubhouseSlug}/discussions/${topicSlug}/start-discussion`,
  CLUBHOUSE_TEMPLATES: (clubhouseSlug: string) => `/clubhouse/${clubhouseSlug}/templates/`,
}
